<h2 mat-dialog-title>Generate Promo Codes</h2>

<form [formGroup]="form" (ngSubmit)="submit()" mat-dialog-content class="form-container">

    <div style="display: flex; flex-direction: column; padding: 10px;">
        <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; gap: 10px;">
            <mat-form-field appearance="outline" style="width: 47%;">
                <mat-label>Number of Codes</mat-label>
                <input matInput type="number" formControlName="numberOfCodes" required />
                @if (form.get('numberOfCodes')?.invalid) {
                <mat-error>Enter a valid number</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 47%;">
                <mat-label>Max number of uses</mat-label>
                <input matInput type="number" formControlName="maxUses" required />
                <mat-hint>0 for unlimited</mat-hint>
                @if (form.get('numberOfCodes')?.invalid) {
                <mat-error>Enter a valid number</mat-error>
                }
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Comment</mat-label>
                <input matInput type="text" formControlName="comment" />
            </mat-form-field>
        </div>

        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
            <mat-form-field appearance="outline" style="width: 47%;">
                <mat-label>Valid Until</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="validUntil" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div>
            <mat-radio-group formControlName="discountType">
                @for (option of discountTypeOptions; track option) {
                <mat-radio-button [value]="option.key">
                    {{ option.label }}
                </mat-radio-button>
                }
            </mat-radio-group>
        </div>

         <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
            @if (form.get('discountType')?.value === 'PERCENT') {
            <mat-form-field appearance="outline" style="width: 47%;">
                <mat-label>Discount</mat-label>
                <mat-select formControlName="percentDiscount">
                    @for (d of predefinedDiscounts; track $index) {
                    <mat-option [value]="d">{{ d }}%</mat-option>
                    }
                    <mat-option [value]="'custom'">Other</mat-option>
                </mat-select>
            </mat-form-field>

            @if (form.get('percentDiscount')?.value === 'custom') {
            <mat-form-field appearance="outline" style="width: 47%;">
                <mat-label>Custom Discount (%)</mat-label>
                <input matInput type="number" formControlName="customPercentDiscount" />
                <mat-hint>Enter a value between 1 and 100</mat-hint>
                <mat-error>Enter a valid percentage</mat-error>
            </mat-form-field>
            }
            } @else {
            <mat-form-field appearance="outline" style="width: 47%;">
                <mat-label>Discount amount</mat-label>
                <input matInput type="number" formControlName="fixedAmountDiscount" />
                <mat-error>Enter a valid amount</mat-error>
            </mat-form-field>
            }
        </div>
    </div>
</form>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="submit()">Generate</button>
</mat-dialog-actions>